import {useDispatch, useSelector} from "react-redux";
import {updateSmaSettings} from "../../../../store/slices/sma.slice";
import React, {useState} from "react";
import {Card, Col, Divider, Row} from "antd";
import SmaSider from "./SmaSider";
import SmaMenu from "./SmaMenu";
import Button from "@mui/material/Button";
import {SortByAlphaRounded, SortRounded} from "@mui/icons-material";
import EtfController from "./EtfController";
import SmaTickersTable from "../../SmaTickersTable";
import SmaStatsBar from "./SmaStatsBar";
import {selectPortfolioById} from "../../../../store/slices/portfolios.slice";

const SmaConfigurator = ({   etfData, tickerData, fullData, etfColors,
                          sectorColors, config, blacklists, screens,
                          summaryDetails, etfContributions, callbacks
})=>{
    const dispatch = useDispatch();
    const sortEtfs = useSelector(state=>state.sma.smaSettings.sortEtfs);
    const linkedPortfolio = useSelector(state=>selectPortfolioById(state, config?.linkedPortfolioId));


    const {
        updateConfig,
        toggleReplicateEtf,
        removeEtf,
        updateEtfWeight,
        saveSma
    } = callbacks

    const toggleSortEtfs = ()=>{
        dispatch(updateSmaSettings({sortEtfs: !sortEtfs}))
    }

    const [collapseEtfs, setCollapseEtfs] = useState(false);


    const toggleEtfBanner = ()=>setCollapseEtfs(!collapseEtfs);
    return (
        <>
            <Row wrap={false}>
                <Col flex={'0 0 300px'} className={'border-r border-gray-200 px-5 py-6'}>
                    <SmaSider blacklists={blacklists}
                              screens={screens}
                              config={config}
                              updateConfig={updateConfig}
                              etfContributions={etfContributions}
                    />
                    <EtfController etfs={etfData} updateEtfWeight={updateEtfWeight} removeEtf={removeEtf}
                                              toggleReplicateEtf={toggleReplicateEtf}
                                              wrap={collapseEtfs} sort={sortEtfs}
                                              etfContributions={etfContributions}
                                              minWeightTolerance={config.minWeightTolerance}
                    />
                </Col>
                <Col flex={'auto'} style={{padding: '0px'}}>
                    <div className={'border-b border-gray-200'}>
                        <div className={'pb-4 border-b border-gray-200 '}>
                            <SmaMenu updateConfig={updateConfig} currentSmaConfig={config} handleSave={saveSma}
                                     showEtfBanner={!collapseEtfs}
                                     toggleEtfBanner={toggleEtfBanner}
                                     extra={
                                        <Button variant={'text'} startIcon={sortEtfs ? <SortRounded /> : <SortByAlphaRounded/>} onClick={toggleSortEtfs}>
                                            {sortEtfs ? 'Sort by Weight' : 'Sort by Symbol'}
                                        </Button>
                                 }

                            />
                        </div>
                        <div className={'p-4'}>
                            <SmaStatsBar summaryDetails={summaryDetails} cutHoldings={tickerData} fullHoldings={fullData}
                                         linkedPortfolio={linkedPortfolio}
                            />
                        </div>
                    </div>
                    <div className={'pl-8'}>
                        {tickerData && <SmaTickersTable data={tickerData} etfColors={etfColors} sectorColors={sectorColors}/>}
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default SmaConfigurator;